<template>
  <div class="flex flex-col md:flex-row min-h-screen items-center bg-gray-200">
    <div class="bg-white w-full md:max-w-md lg:max-w-full my-auto md:mx-auto md:w-1/2 xl:w-1/3 h-auto px-6 lg:px-16 xl:px-12
          flex items-center justify-center rounded shadow-md lg:mt-8 lg:mb-8 xl:mt-8 xl:mb-8">
      <div class="w-full py-6">
        <span>Forgot Password</span>
        <h1 class="text-xl md:text-2xl font-bold leading-tight">Send Password Reset Request</h1>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="mt-6" @submit.prevent="handleSubmit(forgotPassword)">
            <div class="mt-4">
              <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                <label for="email" class="block text-gray-700">Email</label>
                <input type="text" id="email" v-model="email" placeholder="Enter Email Address" class="w-full px-4 py-3 rounded bg-gray-200 mt-2 border focus:border-blue-500 focus:bg-white focus:outline-none" autofocus>
                <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>
                <span v-if="errors.email" class="text-red-600 w-full">{{ errors.email[0] }}</span>
              </ValidationProvider>
              <div v-if="error.email" class="text-sm text-red-600"><span>{{ error.email[0] }}</span></div>               
            </div>         
            <button type="submit" :disabled="isLoading" class="w-full block bg-indigo-600 hover:bg-indigo-700 focus:bg-indigo-700 text-white font-semibold rounded
                  px-4 py-3 mt-6 disabled:opacity-50">
              Submit
            </button>
            <p class="mt-8">
              <router-link v-if="!isLoading" :to="{ name: 'login' }" class="text-gray-500 hover:text-blue-700">Back to Login</router-link>
              <span v-else class="text-gray-500">Back to Login</span>
            </p>
          </form>
        </ValidationObserver>
      </div>
    </div>   
  </div>
</template>

<script>
import authServices from '@/services/user/authServices'

export default {
  name: 'ForgotPassword',
  data(){
    return {
      email: '',
      error: [],
      isLoading: false,
      toastedOptions: {
        position: "top-right", 
        duration : 5000        
      }      
    }
  },
  methods: {
    async forgotPassword(){
      try {
        /* SET LOADING STATE IS TRUE */
        this.isLoading = true

        const response = await authServices.forgotPassword({
          email: this.email
        })
        if (response.data.status === 'success') {
          /* CLEAR INPUT FORM */
          this.email = ''
          
          /* EMPTY ERRORS VARIABLE */
          this.error = []

          this.$toasted.success(response.data.message, this.toastedOptions)

          /* REDIRECT TO LOGIN PAGE */
          this.$router.push('/auth/login')
        } else {
          /* SET LOADING STATE IS FALSE */
          this.isLoading = false

          /* EMPTY ERRORS VARIABLE */
          this.error = []

          /* STORE RESPONSE MESSAGE TO A VARIABLE */
          let responseReturn = response.data.message

          /* IF RESPONSE HAS OBJECT, STORE RESPONSE TO ERRORS VARIABLE */
          if (responseReturn.email) {
            this.error = response.data.message

          /* ELSE, THROW ERROR MESSAGES */
          } else {
            this.$toasted.error(response.data.message, this.toastedOptions)
          }
        }        
      } catch (error) {
          /* SET LOADING STATE IS FALSE */
          this.isLoading = false
                  
          /* EMPTY ERRORS VARIABLE */
          this.error = []

          /* STORE RESPONSE MESSAGE TO A VARIABLE */
          this.error = error.response.data.message  
          
          /* ELSE, THROW ERROR MESSAGES */
          this.$toasted.error(this.error, this.toastedOptions)
      }     
    }
  } 
}
</script>